/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Frame_RateInputs */

const en_subtitle_export_frame_rate = /** @type {(inputs: Subtitle_Export_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Framerate`)
};

const fr_subtitle_export_frame_rate = /** @type {(inputs: Subtitle_Export_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fréquence d'images`)
};

const de_subtitle_export_frame_rate = /** @type {(inputs: Subtitle_Export_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildrate`)
};

const it_subtitle_export_frame_rate = /** @type {(inputs: Subtitle_Export_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequenza dei fotogrammi`)
};

const ru_subtitle_export_frame_rate = /** @type {(inputs: Subtitle_Export_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частота кадров`)
};

const es_subtitle_export_frame_rate = /** @type {(inputs: Subtitle_Export_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de cuadros`)
};

const zh_cn2_subtitle_export_frame_rate = /** @type {(inputs: Subtitle_Export_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帧率`)
};

const ja_subtitle_export_frame_rate = /** @type {(inputs: Subtitle_Export_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレームレート`)
};

const hi_subtitle_export_frame_rate = /** @type {(inputs: Subtitle_Export_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ्रेम रेट`)
};

const pt_pt2_subtitle_export_frame_rate = /** @type {(inputs: Subtitle_Export_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de quadros`)
};

/**
* | output |
* | --- |
* | "Framerate" |
*
* @param {Subtitle_Export_Frame_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_frame_rate = /** @type {((inputs?: Subtitle_Export_Frame_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Frame_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_frame_rate(inputs)
	if (locale === "de") return de_subtitle_export_frame_rate(inputs)
	if (locale === "it") return it_subtitle_export_frame_rate(inputs)
	if (locale === "ru") return ru_subtitle_export_frame_rate(inputs)
	if (locale === "es") return es_subtitle_export_frame_rate(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_frame_rate(inputs)
	if (locale === "ja") return ja_subtitle_export_frame_rate(inputs)
	if (locale === "hi") return hi_subtitle_export_frame_rate(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_frame_rate(inputs)
	return en_subtitle_export_frame_rate(inputs)
});